
//Import NPM Packages
import bootstrap from 'bootstrap';
import 'animate.css';

//Libraries


//Import SCSS for compiling
import '../scss/main.scss';

//Import images to be compressed
import '../img/screenshot.png';

//Import fonts
import '../fonts/garamond/eb-garamond-v15-latin-700.eot';
import '../fonts/garamond/eb-garamond-v15-latin-700.svg';
import '../fonts/garamond/eb-garamond-v15-latin-700.ttf';
import '../fonts/garamond/eb-garamond-v15-latin-700.woff';
import '../fonts/garamond/eb-garamond-v15-latin-700.woff2';

import '../fonts/verdana/Verdana-V2-V1.eot';
import '../fonts/verdana/Verdana-V2-V1.svg';
import '../fonts/verdana/Verdana-V2-V1.ttf';
import '../fonts/verdana/Verdana-V2-V1.woff';
import '../fonts/verdana/Verdana-V2-V1.woff2';

import '../fonts/verdana-bold/Verdana-Bold-V1.eot';
import '../fonts/verdana-bold/Verdana-Bold-V1.svg';
import '../fonts/verdana-bold/Verdana-Bold-V1.ttf';
import '../fonts/verdana-bold/Verdana-Bold-V1.woff';
import '../fonts/verdana-bold/Verdana-Bold-V1.woff2';

